import Label from '@superfunnel/ui-core/v2/Label';
import TextArea from '@superfunnel/ui-core/v2/TextArea';
import { classNames } from '@superfunnel/utils';

interface ISettingTextArea {
  title?: string;
  value?: string;
  setValue?: any;
  rows?: number;
  className?: string;
}

export default function SettingTextArea({
  title,
  value,
  setValue,
  className,
  rows = 6,
}: ISettingTextArea) {
  return (
    <div className="font-inter grid w-full items-center gap-1">
      <Label
        htmlFor="email"
        className="text-base-700 flex items-center gap-2 text-sm font-medium"
      >
        {title}
      </Label>
      <dd className="grid w-full grid-cols-1 gap-2">
        <TextArea
          className={classNames(className)}
          key={'edit-name'}
          value={value}
          onChange={(v) => setValue(v.target.value)}
          rows={rows}
        />
      </dd>
    </div>
  );
}
